import { useEffect, useState } from 'react';

const getBodyBackgroundColor = () => getComputedStyle(document.body).backgroundColor;

export function useBodyBackgroundColor() {
  const [color, setColor] = useState(getBodyBackgroundColor());

  useEffect(() => {
    // Update the color (it may have changed after the cleanup function ran, or it may have changed in between the initial useState setting and this effect being run by React)
    setColor(getBodyBackgroundColor());

    // Set up an observer on the <body> element of the DOM that looks for changes to its style attribute - if any are seen, re-fetch the body background color and update it in state
    const observer = new MutationObserver(() => setColor(getBodyBackgroundColor()));
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['style'],
    });

    return () => observer.disconnect();
  }, []);

  return color;
}
